import { useCallback } from "react";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useActivePerspective from "components/perspectives/hooks/useActivePerspective";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import { getPathnameWithoutId } from "util/URLUtils";
import useLocation from "routing/useLocation";
const useSendEventActionTelemetry = () => {
  const sendTelemetry = useSendTelemetry();
  const { pathname } = useLocation();
  const { activePerspective } = useActivePerspective();
  return useCallback(
    (actionName, fromBulk, eventDetails = {}) => sendTelemetry(TELEMETRY_EVENT_TYPE.ALERTS_AND_EVENTS.ACTION_RAN, {
      app_pathname: getPathnameWithoutId(pathname),
      app_section: "alerts-and-events",
      event_details: {
        actionName,
        fromBulk: !!fromBulk,
        perspectiveId: activePerspective.id,
        ...eventDetails
      }
    }),
    [activePerspective.id, pathname, sendTelemetry]
  );
};
export default useSendEventActionTelemetry;
